import { gql } from '@apollo/client'

export default gql(`
    mutation deleteCountry($id: ID!, $name: String, $project: String) {
        deleteCountry(
                id: $id,
                name: $name,
                project: $project
        ) {
            id
            name
        }
    }`
)
